/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import ParentField from '../ParentField';
import BookSelect from '../BookSelect';

const BookField = React.forwardRef(({ ...props }, ref) => (
  <ParentField
    {...props}
    onRedirect={(selectedParent) => `/books/${selectedParent.id}`}
    linkText="Book setup"
    ref={ref}
  >
    {(parentProps) => <BookSelect {...parentProps} />}
  </ParentField>
));

export default BookField;
